import React from "react";
import "./css/HomePage.css";

const SubCategorySkeleton = () => {
  return (
    <div
      className="container py-4 py-xl-5"
      aria-busy="true"
      aria-label="Loading subcategory content"
    >
      <div className="row mb-5">
        <div className="col-md-8 col-xl-6 text-center mx-auto">
          {/* Subcategory Title Skeleton */}
          <div className="subcategory-skeleton-title skeleton-box">
            <div className="skeleton-pulse" />
          </div>

          {/* Subcategory Description Lines Skeleton */}
          <div
            className="subcategory-skeleton-desc-line skeleton-box"
            style={{ width: "85%" }}
          >
            <div className="skeleton-pulse" />
          </div>
          <div
            className="subcategory-skeleton-desc-line skeleton-box mb-4"
            style={{ width: "65%" }}
          >
            <div className="skeleton-pulse" />
          </div>

          {/* Subcategory Circular Hero Image Skeleton */}
          <div className="mx-auto customimage subcategory-hero-image skeleton-box">
            <div className="skeleton-pulse" />
          </div>
        </div>
      </div>

      {/* Content Items Grid Skeleton */}
      <div className="row gy-4 row-cols-1 row-cols-md-2 row-cols-xl-3 p-2">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
          <div className="col text-center" key={i}>
            <div
              className="subcategory-skeleton-content-item skeleton-box"
              style={{ width: `${60 + (i % 3) * 12}%` }}
            >
              <div className="skeleton-pulse" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubCategorySkeleton;

